import { isElectronApp, requireFromElectron } from '../services/crossPlatform/crossPlatformService';
import { I18n } from 'react-redux-i18n-lite';
import { removeAuthTokenFromStorage, removeBooksFromStorage, removeRefreshTokenFromStorage } from '../shared';
import _ from 'lodash';
import { isContentBooksDownloadingOrUnzipping } from '../utils/contentUtils';
import { cancelBookDownload, setCdnSynchronization } from '../actions/contentActions';
import { CDN_SYNCHRONIZATION_STATUS } from '../const';

const electron = requireFromElectron('electron');

export const startIpcMessages = store => {
  if (isElectronApp() && electron) {
    listenerElectronAppIsDownloadingOrUnzipping();
    listenerElectronAppStopDownloadsAndClose(store);
    listenerElectronAppModalTranslations();
    listenerElectronAppUpdateWindow();
    // listenerElectronAppStopDownloads(store);
    listenerElectronAppSetLoggout(store);
    closeAppListener();
  }
};

function listenerElectronAppIsDownloadingOrUnzipping() {
  electron.ipcRenderer.on('app-dialog-download-or-unzipping', event => {
    const args = {
      buttons: [I18n.t('electron.closeModal.cancel'), I18n.t('electron.closeModal.success')],
      message: I18n.t('electron.closeModal.message'),
      detail: I18n.t('electron.closeModal.detailDownload')
    };
    event.sender.send('app-dialog-download-or-unzipping-reply', args);
  });
}

const listenerElectronAppSetLoggout = store => {
  electron.ipcRenderer.on('logout-webapp', event => {
    removeBooksFromStorage();
    window.localStorage.removeItem('smartAuthUserId');
    window.localStorage.removeItem('configuration');
  });
};

const listenerElectronAppStopDownloadsAndClose = store => {
  electron.ipcRenderer.on('stop-downloads-and-close', event => {
    const { dispatch, getState } = store;
    const { contentBooks } = getState().content;
    const userId = getState().account.user._id;
    const booksDownloadingOrUnzipping = isContentBooksDownloadingOrUnzipping(contentBooks);
    dispatch(setCdnSynchronization(CDN_SYNCHRONIZATION_STATUS.EMPTY));
    const Promises = booksDownloadingOrUnzipping.map(contentBook => {
      localStorage.removeItem(`saveBook_${contentBook.bookId}`);
      return dispatch(cancelBookDownload(contentBook, userId));
    });
    Promise.all([Promises]).then(() => event.sender.send('stop-downloads-and-close-reply', {}));
  });
};

function listenerElectronAppModalTranslations() {
  electron.ipcRenderer.on('close-app-dialog-translations', event => {
    const args = {
      buttons: [I18n.t('electron.closeModal.cancel'), I18n.t('electron.closeModal.success')],
      message: I18n.t('electron.closeModal.message'),
      detail: I18n.t('electron.closeModal.detail')
    };
    event.sender.send('close-app-dialog-translations-reply', args);
  });
}

export const sendExpiredToken = expired => {
  electron.ipcRenderer.send('application-expired-token', { expired });
};

const closeAppListener = () => {
  electron.ipcRenderer.on('close-app-and-logout', () => {
    removeAuthTokenFromStorage();
    removeRefreshTokenFromStorage();
  });
};

function listenerElectronAppUpdateWindow() {
  electron.ipcRenderer.send('send-update-translations', {
    message: I18n.t('autoupdater')
  });
}

export const sendDownloadingOrUnzippingBooks = (contentBooks, value) => {
  if (!_.isNil(value)) {
    electron.ipcRenderer.send('update-downloading-or-unzipping-on-electron', value);
  } else {
    electron.ipcRenderer.send(
      'update-downloading-or-unzipping-on-electron',
      Boolean(isContentBooksDownloadingOrUnzipping(contentBooks).length)
    );
  }
};

export const sendDownloadingOrUnzippingCdnOrSkin = value => {
  electron.ipcRenderer.send('update-downloading-or-unzipping-cdn-or-skin', value);
};
